import { z } from "zod";
import { QcConversationMemberSchema } from "./QcConversationMember";
import { GroupMemberSchema } from "./GroupMember";

export type ModelConversationMemberList = z.infer<typeof ModelConversationMemberListSchema>;
export const ModelConversationMemberListSchema = z.object({
  // items: z.array(QcConversationMemberSchema),
  items: z.array(GroupMemberSchema),
  nextPage: z.number(),
});
